<template>
    <a
        :href="iframeLink ? iframeLink : 'javascript:void(0);'"
        :target="iframeLink ? '_blank' : ''"
        @click="iframeLink ? '' : !isFullscreen ? goFullscreen() : exitFullscreen()"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
            ></path>
        </svg>
    </a>
</template>

<script>
export default {
    props: {
        iframeLink: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isFullscreen: false
        };
    },
    methods: {
        goFullscreen() {
            const btn = document.querySelector('.mapboxgl-ctrl-fullscreen');
            btn.click();
            this.isFullscreen = true;
        },
        exitFullscreen() {
            const btn = document.querySelector('.mapboxgl-ctrl-shrink');
            btn.click();
            this.isFullscreen = false;
        }
    }
};
</script>

<style>
</style>